import type { PropsWithChildren } from 'react';
import { AnalyticsProvider } from '@/contexts/AnalyticsContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <ThemeProvider>
      <AnalyticsProvider>
        <AuthProvider>{children}</AuthProvider>
      </AnalyticsProvider>
    </ThemeProvider>
  );
}
